import user from "../../assets/img/user.png";
import { Link, useNavigate } from "react-router-dom";
import { FaPowerOff, FaUserTie, FaHome } from "react-icons/fa";
import { MdDashboardCustomize } from "react-icons/md";
import { getLoginInfo } from "../utils/storage";

function Sidebar() {
  const Roles = getLoginInfo();
  const username =
    getLoginInfo()?.user?.Username?.replace(/@immigration\.go\.tz$/i, "") || "";

  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  var today = new Date(),
    date =
      today.getDate() +
      "/" +
      (today.getMonth() + 1) +
      "/" +
      today.getFullYear();
  var currentDate = date;
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

  <script type="text/javascript">
    function preventBack() {window.history.forward()}
    setTimeout("preventBack()", 0); window.onunload = function () {null};
  </script>;

  return (
    <>
      <div
        className="sidebar"
        data-color="purple"
        data-background-color="white"
        data-image="{}"
        alt="sidebar-1"
      >
        <div className="logo">
          <center>
            <img src={user} width="130px" height="120px" />
            <br />
            <br />
            <b>{username}</b>
            <br />
            <b>{getLoginInfo()?.user?.StationName}</b>
          </center>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {getLoginInfo()?.user?.GroupName === "Super Admin" && (
              <li className="nav-item">
                <Link to="/dashboard" className="nav-link">
                  <p>
                    <FaHome style={{ fontSize: "17px" }} />
                    &nbsp;&nbsp; Main Dashboard
                  </p>
                </Link>
              </li>
            )}

            <li className="nav-item active">
              <Link to="/etd" className="nav-link">
                <p>
                  <MdDashboardCustomize style={{ fontSize: "15px" }} />
                  &nbsp;&nbsp; ETD Dashboard
                </p>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="/edituser" className="nav-link">
                <p>
                  <FaUserTie style={{ fontSize: "15px" }} />
                  &nbsp;&nbsp; Change Profile
                </p>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link to={"/"} onClick={handleLogout} className="nav-link">
                <p>
                  <FaPowerOff style={{ fontSize: "15px" }} />
                  &nbsp;&nbsp; Sign-out
                </p>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
